import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import TextButton from 'components/Button/TextButton';
import plusIcon from 'assets/img/plus-icon.svg';
import iconProfile from 'assets/img/icons/profile.svg';
import { Creators as FormCreators } from 'store/ducks/serviceForm';
import { Creators as AuthCreators, getTriiderUser, isAuth } from 'store/ducks/auth';

import { initializeGA, gaSendEvent } from '../../utils/analytics';

import {
  HeaderStyled,
  Logo,
  CompanyLogo,
  Right,
  UserDropdown,
  UserPhoto,
  UserName,
  DropDownOptions,
  HeaderOptions,
  Name,
  Email,
  List,
  Item,
} from './styles';

class Header extends Component {
  refDropDown = React.createRef();

  refListDropDown = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.initGa();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.triiderUser !== this.props.triiderUser) {
      this.initGa();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }


  handleClickOutside = (event) => {
    if (
      (this.refDropDown || this.refListDropDown)
      && this.refDropDown.current
        && !this.refDropDown.current.contains(event.target)
        && this.refListDropDown.current
        && !this.refListDropDown.current.contains(event.target)
    ) {
      this.setState({ dropdownOpen: false });
    }
  };

  toggleDropdown = () => {
    const { dropdownOpen } = this.state;
    this.setState({ dropdownOpen: !dropdownOpen });
  };

  logout = async () => {
    const { _logout } = this.props;
    await localStorage.removeItem('triiderUser');
    _logout();
    this.setState({ dropdownOpen: false });
  };

  createTask = () => {
    const { _openForm, _finishForm } = this.props;
    gaSendEvent('novo_pedido', 'header');
    _openForm({
      isOpen: true,
      isFormAddress: false,
      address: null,
      onFinish: _finishForm,
      selectedAddress: null,
    });
  };

  initGa = () => {
    const { triiderUser } = this.props;
    if (triiderUser && triiderUser.user) {
      initializeGA(triiderUser.user.id);
      // console.log('initializeGA');
    }
  };

  render() {
    const {
      _openForm, _finishForm, _isAuth, triiderUser,
    } = this.props;
    const { dropdownOpen } = this.state;

    const { user = {}, company = {} } = triiderUser || {};
    return (
      <Fragment>
        <HeaderStyled>
          <Logo />
          {_isAuth() ? (
            <Right>
              <TextButton
                btnIcon={plusIcon}
                noShadow
                btnWidth="130px"
                onClick={() => this.createTask(_openForm, _finishForm)}
              >
                Novo pedido
              </TextButton>
              {company.logo_url ? <CompanyLogo src={company.logo_url} /> : <div />}
              <UserDropdown
                onClick={() => {
                  this.toggleDropdown();
                }}
                ref={this.refDropDown}
              >
                <UserPhoto src={user.profile_picture || iconProfile} />
                <UserName>{user ? user.name.split(' ')[0] : ''}</UserName>
              </UserDropdown>
            </Right>
          ) : (
            ''
          )}
        </HeaderStyled>
        <DropDownOptions isOpen={dropdownOpen} ref={this.refListDropDown}>
          <HeaderOptions>
            <Name>{user.name}</Name>
            <Email>{user.email}</Email>
          </HeaderOptions>
          <List>
            {/* <Item>Configuração de perfil</Item>
            <Item>Configuração da conta</Item> */}
            <Item
              onClick={() => {
                this.logout();
              }}
            >
              Sair
            </Item>
          </List>
        </DropDownOptions>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  triiderUser: state.auth.triiderUser,
  _isAuth: () => isAuth(state),
});

const mapDispatchToProps = {
  _openForm: FormCreators.openForm,
  _finishForm: FormCreators.finishFormRequest,
  _logout: AuthCreators.logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
